// eslint-disable-next-line no-unused-vars
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useRouter from 'Hooks/useRouter';
import useFetch from 'Hooks/useFetch';
import useUser from 'Hooks/useUser';
import useAsyncError from 'Hooks/useAsyncError';
import useNumberUtils from 'Hooks/useNumberUtils';
import useAnalytics from 'Hooks/useAnalytics';
import download from 'Utils/download';
import AccountInfoComponent from 'Components/Account/AccountInfo';
import { API_ACCOUNT_INFO, BATTERY_TARIFF, API_BATTERY_TARIFF } from 'Constants';

const AccountInfo = memo(() => {
  const [informationData, setInformationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetcher = useFetch();
  const { formatDate } = useNumberUtils();
  const throwError = useAsyncError();
  const { data: { email, loggedIn } = {} } = useUser();
  const { query, location } = useRouter();
  const { t } = useTranslation();
  const analytics = useAnalytics();

  const getAccountProfile = () => {
    setLoading(true);

    Promise.all([
      fetcher(API_ACCOUNT_INFO),
      fetcher(API_BATTERY_TARIFF)
    ]).then(([accountInfoRes, batteryTariffRes]) => {
      setInformationData([
        {
          uploadedInformationId: 0,
          type: 'csv',
          informationType: 2,
          fileName: t('user.regulationsTitle'),
          linkName: t('user.regulationsTitle'),
          linkUrl: BATTERY_TARIFF,
          updatedAt: batteryTariffRes?.batteryTariffUpdatedAt,
        },
        ...(accountInfoRes?.map(item => ({
          ...item,
          updatedAt: formatDate((item?.updated || item?.added), { timeStyle: undefined })
        })) || []),
      ]);
    }).catch(err => throwError(err))
      .finally(() => setLoading(false));
  };

  const handleDownload = url => {
    analytics.track('download_clicked');
    download(url);
  };

  // Get Profile data on page load
  useEffect(() => {
    if (loggedIn) {
      getAccountProfile();
    }
  }, [location.pathname, query, email, loggedIn]);

  return (
    <AccountInfoComponent
      loading={ loading }
      informationData={ informationData }
      handleDownload={ handleDownload }
    />
  );
});

AccountInfo.displayName = 'AccountInfoContainer';

export default AccountInfo;
